import { inject, Injectable } from '@angular/core';
import {
  ApiDataAccess,
  Dictionary,
  ReadonlyHttpApiListRepository,
  Result,
} from '@softline/core';
import { SOFTLINE_API_ROHSTOFFBILANZ_QUERY_DETAIL } from '../rohstoffbilanz.api';
import { RohstoffbilanzResult } from '../data/result';

@Injectable()
export class RohstoffbilanzRepository extends ReadonlyHttpApiListRepository<
  Result<RohstoffbilanzResult[]>,
  Dictionary<unknown> | undefined
> {
  constructor() {
    super(inject(ApiDataAccess), SOFTLINE_API_ROHSTOFFBILANZ_QUERY_DETAIL);
  }

  protected override getLoadPayload(
    params: Dictionary<unknown> | undefined
  ): Dictionary<unknown> | undefined {
    return params;
  }
}
